var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 2.55298C0.333252 1.44841 1.22868 0.552979 2.33325 0.552979H22.3333C23.4378 0.552979 24.3333 1.44841 24.3333 2.55298V22.553C24.3333 23.6575 23.4378 24.553 22.3333 24.553H2.33325C1.22868 24.553 0.333252 23.6575 0.333252 22.553V2.55298Z",
    fill: "#EDDF65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83319 16.053L6.91652 13.1363C6.59152 12.8113 6.07485 12.8113 5.74985 13.1363C5.42485 13.4613 5.42485 13.978 5.74985 14.303L9.24152 17.7946C9.56652 18.1196 10.0915 18.1196 10.4165 17.7946L19.2499 8.96962C19.5749 8.64462 19.5749 8.12795 19.2499 7.80295C18.9249 7.47795 18.4082 7.47795 18.0832 7.80295L9.83319 16.053Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/CheckedCheckbox.1275f4d8ff3e95239984b5d3c73e5dd2.svg";
export { ForwardRef as ReactComponent };